export default {
  title: 'Er du sikker på, at du vil slette din konto?',
  description: 'Denne handling er permanent. Du mister adgangen til dine ordrer, loyalitetspoint og gemte præferencer.',
  labels: {
    loading: 'Sletter din konto...',
  },
  buttons: {
    confirm: 'Bekræft',
    cancel: 'Annuller',
  },
  toasts: {
    success:
      'Din konto er blevet slettet permanent. Du har ikke længere adgang til din ordrehistorik, dine loyalitetspoint eller gemte data.',
    error: 'Noget gik galt. Prøv igen. Hvis problemet fortsætter, kontakt venligst vores support: {{supportEmail}}',
  },
};
